// Third-party
import React from 'react';
import classNames from 'classnames';

export type SimpleTableRows = Array<{
  elements: React.ReactNode[];
  className?: string;
}>;

type Props = {
  className?: string;
  data: {
    rows: SimpleTableRows;
    headers: React.ReactNode[];
  };
  stickyHeaders?: boolean;
};

const SimpleTable = ({ data, className, stickyHeaders }: Props) => {
  const { rows, headers } = data;

  return (
    <table className={classNames('simple-table', className, { 'sticky-headers': stickyHeaders })}>
      <thead>
        <tr>
          {headers.map((header, index) => (
            <th key={index}>{header}</th>
          ))}
        </tr>
      </thead>

      <tbody>
        {rows.map((row, index) => (
          <tr className={row.className} key={index}>
            {row.elements.map((el, index) => (
              <td key={index}>{el}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default SimpleTable;
